module.exports = __webpack_public_path__ + "img/bg-pride-day.16bd94f9.svg";